<template>
    <div class="position-relative">
        <div v-if="countCreatedResponse < 1" class="root-preloader position-absolute overlay-loader-wrapper">
            <div class="spinner-bounce d-flex align-items-center dashboard-preloader justify-content-center">
                <span class="bounce1 mr-1"></span>
                <span class="bounce2 mr-1"></span>
                <span class="bounce3 mr-1"></span>
                <span class="bounce4"></span>
            </div>
        </div>
        <div class="content-wrapper">
            <app-breadcrumb :page-title="$t('default_name')" :directory="$t('dashboard')" :icon="'pie-chart'"/>

            <app-overlay-loader v-if="!defaultData && !mainPreloader"/>
            <div class="row" v-if="defaultData">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                     v-for="(item, index) in info.getDefaultDashboardInfo.topSectionData" :key="index">
                    <app-widget class="mb-primary"
                                :type="'app-widget-with-icon'"
                                :label="item.label"
                                :number="item.number"
                                :icon="item.icon"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import {DashboardPreloader} from "./Mixins/DashboardPreloader";
    import * as actions from '../../../../Config/ApiUrl';

    export default {

        mixins: [FormMixin,DashboardPreloader],
        name: "Dashboard",
        data() {
            return {
                /* Loader section and active/inactive section */
                mainPreloader: true,
                defaultData: false,
                /* end */
                info: {},
            }
        },
        created() {
            this.mainPreloader = true;
            this.getDefaultDashboardInfo();
        },
        methods: {
            getDefaultDashboardInfo() {

                let url = actions.DEFAULT_DASHBOARD_INFO;

                this.axiosGet(url).then(response => {

                    this.info.getDefaultDashboardInfo = response.data;
                    this.defaultData = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
        }
    }
</script>
